import { useQuery } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

export const useRapportCQPreviewQuery = (idCQ: string | undefined) => {
  return useQuery({
    queryKey: controleQuinquennalKeys.rapportPreview(idCQ ?? ""),
    queryFn: () => ControleQuinquennalApi.getRapportPreview(idCQ as string),
    enabled: !!idCQ,
    staleTime: 0,
    gcTime: 0,
  });
};
